export default __webpack_public_path__ + "static/media/6-icon.1bb42961.svg";